import { Component, OnInit } from '@angular/core';

/**
 * Class for not logged in component
 */
@Component({
  selector: 'app-not-logged-in',
  templateUrl: './not-logged-in.component.html',
  styleUrls: ['./not-logged-in.component.css']
})
export class NotLoggedInComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
